<header class="header-wrapper">
  <div class="left">
    <app-somfypro-logo [url]="somfyProUrl"></app-somfypro-logo>
    <div class="separator"><!--&#x7c;--></div>
    <a class="servego-logo-wrapper seg-cursor-pointer" routerLink="/">
      <img class="serv-e-go-logo" src="assets/img/servego_yellow.svg" />
    </a>
  </div>
  <div class="menu-items">
    <app-nav-tab [tabs]="tabs()" />
    <app-notification-popover [active]="notificationsActive()" (clicked)="trackNotificationsClicked()" />
    <div class="separator"><!--&#x7c;--></div>
    <app-side-nav [userLogin]="userLogin" />
  </div>
</header>

<div class="content-wrapper">
  <router-outlet></router-outlet>
</div>

<app-toaster-host></app-toaster-host>

<app-iadvize></app-iadvize>

<app-sign-legal-document-modal
  [open]="legalDocumentSigning.open()"
  [documentType]="legalDocumentSigning.currentDocument()?.documentType"
  [documentUrl]="legalDocumentSigning.currentUrl()"
  [loading]="legalDocumentSigning.loading()"
  (confirmed)="legalDocumentSigning.approveCurrent()"
/>
